
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@comps/ui/tooltip";
import { ObjectInfos } from "@dto/objects";
import { updateStorageSelection } from "@utils/localStorage";
import { getWsButtonStyle, TW_ShowViewIcon, TW_ViewListItem, TW_ViewListItemIcon, TW_ViewListItemSelected, TW_ViewListItemText } from "@utils/twClasses";
import { Eye, EyeSlash, Setting2 } from "iconsax-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useModelStore, useUserStore } from "src/store";

interface ObjectConfigViewProps {
  object: ObjectInfos,
  onMobileClose?: () => void;
  showUserViews?: boolean;
  onShowHideUserViews?: (event: React.MouseEvent<SVGElement>) => void;
}

function ObjectConfigView({ object: objectInfos, onMobileClose, showUserViews, onShowHideUserViews }: ObjectConfigViewProps) {

  const workspace = useModelStore(state => state.selectedWorkspace);
  const selectedObjectInfos = useModelStore(state => state.selectedObjectInfos);
  const selectView = useModelStore(state => state.selectView);
  const selectedView = useModelStore(state => state.selectedView);
  const navigate = useNavigate();
  const wsHoverColor = useModelStore(state => state.wsHoverColor);
  const wsColor = useModelStore(state => state.wsColor);
  const wsDarkColor = useModelStore(state => state.wsDarkColor);
  const [isHover, setIsHover] = useState(false);
  const user = useUserStore(state => state.user);
  const { t } = useTranslation();

  const onSelection = () => {
    if (!workspace?._key) {
      console.error("Workspace key is not set");
      return;
    }

    // Always close mobile sidebar when clicked
    if (onMobileClose) {
      onMobileClose();
    }

    // Do nothing if the object is the same
    if (selectedObjectInfos?.object._key === objectInfos.object._key && selectedView === null) {
      return;
    }

    if (selectedObjectInfos === null || selectedObjectInfos.object._key !== objectInfos.object._key || selectedView?._key !== null) {
      selectView(objectInfos, null, null);
      updateStorageSelection(workspace?._key, objectInfos.object?._key, null, null);
      navigate(`/workspaces/${workspace._key}/objects`);
    }
  }

  let style = isHover ? getWsButtonStyle(wsHoverColor, null, wsColor) : getWsButtonStyle('transparent', null, wsColor);
  let selected = selectedObjectInfos && selectedObjectInfos?.object._key === objectInfos.object._key && selectedView === null;
  const isAdmin = user?.owner;
  return (
    <div className={`${selected ? TW_ViewListItemSelected : TW_ViewListItem}`}
      onClick={onSelection}
      style={style}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}>
      <Setting2 className={TW_ViewListItemIcon} color={wsDarkColor} />
      <p className={TW_ViewListItemText}>{t("object.config.view")}</p>
      {isAdmin && showUserViews &&
        <TooltipProvider>
          <Tooltip delayDuration={100}>
            <TooltipTrigger>
              <Eye className={TW_ShowViewIcon} onClick={onShowHideUserViews} />
            </TooltipTrigger>
            <TooltipContent>
              {t("object.config.view.hide.other.users.views.tooltip")}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>}
      {isAdmin && !showUserViews &&
        <TooltipProvider>
          <Tooltip delayDuration={100}>
            <TooltipTrigger>
              <EyeSlash className={TW_ShowViewIcon} onClick={onShowHideUserViews} />
            </TooltipTrigger>
            <TooltipContent>
              {t("object.config.view.show.other.users.views.tooltip")}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>}
    </div>
  )
}

export default ObjectConfigView;